/**
 * 科技人才模块配置文件
 * 支持多语言切换
 */
import { deepCloneConfig } from '@/utils/deepCloneConfig'
import { applyPortalZhToRu } from '@/utils/applyPortalZhToRu'
import { L, resolveLocaleImages } from '@/utils/localeAsset'

// 中文配置
const zhCN = {
  // 网站信息
  siteInfo: {
    title: '杨凌农业科技成果转化综合信息服务平台',
    logo: L('shouye/web-logo.png'),
    loginText: '登录',
    registerText: '注册'
  },
  
  // 科技人才页面
  techTalent: {
    // 页面标题
    title1: '科技',
    title2: '人才',
    subtitle: '赋能科技创新 助力成果转化',
    searchPlaceholder: '请输入关键词进行搜索',
    searchButton: '搜索',
    
    breadcrumb: {
      home: '首页',
      current: '科技人才'
    },
    
    // 筛选条件
    filters: {
      domain: '所属领域：',
      talentType: '人才类型：',
      province: '省份地区：',
      all: '全部'
    },
    
    // 领域列表
    domainList: [
      '全部', '大田作物', '经济作物', '畜牧养殖', '水产', '林业', '设施农业', '中药材', '农业废弃物', '其他'
    ],
    
    // 人才类型列表
    talentTypeList: [
      '全部', '创业导师', '技术专家', '财务专家', '法律专家', '知识产权专家', '技术转移专家', '创新专家', '产业人才', '其他'
    ],
    
    // 省份地区列表
    provinceList: [
      '全部', '北京市', '天津市', '河北省', '山西省', '内蒙古自治区', '辽宁省', '吉林省', '黑龙江省', '上海市', 
      '江苏省', '浙江省', '安徽省', '福建省', '江西省', '山东省', '河南省', '湖北省', '湖南省', '广东省', 
      '广西壮族自治区', '海南省', '重庆市', '四川省', '贵州省', '云南省', '西藏自治区', '陕西省', '甘肃省', '青海省', 
      '宁夏回族自治区', '新疆维吾尔自治区', '台湾省', '香港特别行政区', '澳门特别行政区', '国外'
    ],
    
    // 人才卡片
    talentCard: {
      research: '所属领域：',
      region: '所属地区：'
    },
    
    // 分页
    pagination: {
      pageInfo: '共{total}条，每页显示{pageSize}条',
      firstPage: '首页',
      prevPage: '上一页',
      nextPage: '下一页',
      lastPage: '末页'
    },
    
    // 资源文件
    assets: {
      bannerBg: L('kejirencai/head-bg@2x.png'),
      itemBg: L('kejirencai/item-bg.png'),
      itemLine: L('kejirencai/item-line.png'),
      textImg: L('kejirencai/kejirencai-text.png'),
      avatarImg: L('default.png')
    }
  },
  
  // 科技人才详情页
  talentDetail: {
    breadcrumb: {
      home: '首页',
      list: '科技人才',
      current: '科技人才详情'
    },
    banner: {
      domainLabel: '擅长领域：',
      regionLabel: '所在区域：',
      contact: '我要对接',
      collect: '收藏',
      collected: '已收藏：',
      collectUnit: '次'
    },
    sections: {
      info: {
        title: '基本信息',
        subtitle: 'BASIC INFORMATION',
        workplace: '工作单位',
        education: '学历',
        profTitle: '职称',
        phone: '联系方式',
        address: '联系地址'
      },
      profile: {
        title: '个人简介',
        subtitle: 'PERSONAL PROFILE',
        background: '专业背景',
        coreField: '核心专业领域',
        advantage: '服务优势'
      },
      similar: {
        title: '类似人才',
        subtitle: 'SIMILAR TALENTS',
        domainLabel: '擅长领域：',
        regionLabel: '所在区域：'
      }
    }
  },
  
  // 功能模块
  modules: [
    {
      id: 'home',
      name: '首页',
      icon: '',
      link: '/index'
    },
    {
      id: 'innovation',
      name: '走进杨凌',
      icon: '',
      link: '/innovation'
    },
    {
      id: 'supply',
      name: '供需中心',
      icon: '',
      link: '/supply-demand'
    },
    {
      id: 'evaluation',
      name: '价值评估',
      icon: '',
      link: '/value-assessment'
    },
    {
      id: 'manager',
      name: '技术经理人',
      icon: '',
      link: '/manager'
    },
    {
      id: 'transaction',
      name: '交易中心',
      icon: '',
      link: '/transaction'
    },
    {
      id: 'service',
      name: '科创服务',
      icon: '',
      link: '/innovation-service'
    },
    {
      id: 'talent',
      name: '科技人才',
      icon: '',
      link: '/talent'
    },
    {
      id: 'enterprise',
      name: '农业企业',
      icon: '',
      link: '/agriculture-enterprise'
    },
    {
      id: 'policy',
      name: '政策信息',
      icon: '',
      link: '/policy'
    }
  ],
  
  // 页脚信息
  footer: {
    copyright: '',
    support: '技术支持：浪潮软件科技有限公司'
  }
}

// 英文配置（预留）
const enUS = {
  siteInfo: {
    title: 'Yangling Agriculture Technology Achievements Transformation Comprehensive Information Platform',
    logo: L('shouye/web-logo.png'),
    loginText: 'Login',
    registerText: 'Register'
  },
  modules: [
    { id: 'home', name: 'Home', icon: '', link: '/index' },
    { id: 'innovation', name: 'Innovation Yangling', icon: '', link: '/innovation' },
    { id: 'supply', name: 'Supply & Demand', icon: '', link: '/supply-demand' },
    { id: 'evaluation', name: 'Value Assessment', icon: '', link: '/value-assessment' },
    { id: 'manager', name: 'Tech Managers', icon: '', link: '/manager' },
    { id: 'transaction', name: 'Transaction Center', icon: '', link: '/transaction' },
    { id: 'service', name: 'Innovation Services', icon: '', link: '/innovation-service' },
    { id: 'talent', name: 'Tech Talent', icon: '', link: '/talent' },
    { id: 'enterprise', name: 'Agricultural Enterprises', icon: '', link: '/agriculture-enterprise' },
    { id: 'policy', name: 'Policy', icon: '', link: '/policy' }
  ],
  footer: {
    copyright: '',
    support: 'Technical Support: Inspur Software Technology Co., Ltd.'
  },
  // 科技人才页面
  techTalent: {
    title1: 'Tech',
    title2: 'Talent',
    subtitle: 'Empowering sci-tech innovation, enabling achievement commercialization',
    searchPlaceholder: 'Please enter keywords to search',
    searchButton: 'Search',
    
    breadcrumb: {
      home: 'Home',
      current: 'Tech Talent'
    },
    
    filters: {
      domain: 'Domain:',
      talentType: 'Talent Type:',
      province: 'Province:',
      all: '全部'
    },
    
    domainList: [
      '全部', 'Field Crops', 'Economic Crops', 'Animal Husbandry', 'Aquaculture', 'Forestry', 'Facility Agriculture', 'Chinese Medicinal Materials', 'Agricultural Waste', 'Other'
    ],
    
    talentTypeList: [
      '全部', 'Entrepreneurship Mentor', 'Technical Expert', 'Financial Expert', 'Legal Expert', 'Intellectual Property Expert', 'Technology Transfer Expert', 'Innovation Expert', 'Industry Talent', 'Other'
    ],
    
    provinceList: [
      '全部', 'Beijing', 'Tianjin', 'Hebei', 'Shanxi', 'Inner Mongolia', 'Liaoning', 'Jilin', 'Heilongjiang', 'Shanghai',
      'Jiangsu', 'Zhejiang', 'Anhui', 'Fujian', 'Jiangxi', 'Shandong', 'Henan', 'Hubei', 'Hunan', 'Guangdong',
      'Guangxi', 'Hainan', 'Chongqing', 'Sichuan', 'Guizhou', 'Yunnan', 'Tibet', 'Shaanxi', 'Gansu', 'Qinghai',
      'Ningxia', 'Xinjiang', 'Taiwan', 'Hong Kong', 'Macau', 'Abroad'
    ],
    
    talentCard: {
      research: 'Domain:',
      region: 'Region:'
    },
    
    pagination: {
      pageInfo: 'Total {total} items, {pageSize} items per page',
      firstPage: 'First',
      prevPage: 'Previous',
      nextPage: 'Next',
      lastPage: 'Last'
    }
  },
  talentDetail: {
    breadcrumb: {
      home: 'Home',
      list: 'Tech Talent',
      current: 'Talent Detail'
    },
    banner: {
      domainLabel: 'Domain:',
      regionLabel: 'Region:',
      contact: 'Contact',
      collect: 'Favorite',
      collected: 'Favorited:',
      collectUnit: 'times'
    },
    sections: {
      info: {
        title: 'Basic Information',
        subtitle: 'BASIC INFORMATION',
        workplace: 'Workplace',
        education: 'Education',
        profTitle: 'Title',
        phone: 'Phone',
        address: 'Address'
      },
      profile: {
        title: 'Personal Profile',
        subtitle: 'PERSONAL PROFILE',
        background: 'Background',
        coreField: 'Core Field',
        advantage: 'Advantages'
      },
      similar: {
        title: 'Similar Talents',
        subtitle: 'SIMILAR TALENTS',
        domainLabel: 'Domain:',
        regionLabel: 'Region:'
      }
    }
  }
}

const ruRU = applyPortalZhToRu(deepCloneConfig(zhCN))

// 当前语言配置
let currentLang = 'zh-CN'

// 语言配置映射
const langMap = {
  'zh-CN': zhCN,
  'en-US': enUS,
  'ru-RU': ruRU
}

// 获取配置
export function getTechTalentConfig(lang) {
  const locale = lang || currentLang
  const config = langMap[locale] || zhCN
  return resolveLocaleImages(config, locale)
}

// 设置语言
export function setLanguage(lang) {
  if (langMap[lang]) {
    currentLang = lang
  }
}

// 获取当前语言
export function getCurrentLanguage() {
  return currentLang
}

export default {
  getTechTalentConfig,
  setLanguage,
  getCurrentLanguage
}